import { useEffect } from 'react';

/**
 * Custom hook to handle chart resizing when the container changes size.
 * @param {React.RefObject} containerRef - Reference to the container element.
 * @param {Object} chartInstance - Chart instance to be resized.
 */
const useChartResize = (containerRef, chartInstance) => {
    useEffect(() => {
        if (!containerRef?.current || !chartInstance) { return; }

        let timeoutId = null;

        const handleResize = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                chartInstance?.current?.chart?.reflow(); // Trigger chart reflow
            }, 150);
        };

        const observer = new ResizeObserver(handleResize);
        observer.observe(containerRef?.current);

        return () => {
            observer.disconnect(); // Cleanup observer
            if (timeoutId) {
                clearTimeout(timeoutId); // Cleanup timeout
            }
        };
    }, [containerRef, chartInstance]);
};

export default useChartResize;
